<!-- 
1、最新资讯，资讯按上传时间第一条，点击跳转资讯详情界面；
2、虚拟展馆，点击跳转虚拟展馆浏览页面（链接写死）；
3、鉴宝赏析，点击跳转鉴宝赏析界面；
4、遇见文物，点击跳转遇见文物界面；
5、创作中心，点击跳转资产库资产管理界面；
6、版权登记，点击跳转版权登记界面；
7、帮助中心，点击跳转帮助中心界面； 
-->
<template>
  <div class="list">
    <div class="list-item" :style="{backgroundImage: 'url(' + props.news.iconImg + ')'}" @click="jumpUrl({id: props.news.id })">
      <i class="span-icon"/>
      <span class="span-label">{{ props.news.title }}</span>
    </div>
    <template v-for="item in list" :key="item.path">
      <div class="list-item" :style="{backgroundImage: 'url(' + item.iconUrl + ')'}" @click="jumpUrl(item)">
        <!-- <i class="span-icon"/> -->
        <span class="span-label">{{ item.label }}</span>
      </div>
    </template>
  </div>
</template>

<script setup>
import {reactive} from 'vue'
import {useRouter} from 'vue-router'
import loginAuth from '../../../utils/loginAuth';
const { isLogin } = loginAuth()

import image1 from '@/assets/images/quick-route/1.png'
import image2 from '@/assets/images/quick-route/2.png'
import image3 from '@/assets/images/quick-route/3.png'
import image4 from '@/assets/images/quick-route/4.png'
import image5 from '@/assets/images/quick-route/5.png'
import image6 from '@/assets/images/quick-route/6.png'

defineOptions({ name: 'QuickRoute' })
const router = useRouter()
const props = defineProps({
  news: {
    type: Object,
    default: () => ({})
  }
})
const list = reactive([
  // {path: '/virtual-hall', label: '虚拟展馆', iconUrl: image1},
  {path: '/art', label: '鉴宝赏析', iconUrl: image2},
  {path: '/collection', label: '遇见文物', iconUrl: image3},
  {path: '/login', label: '创作中心', isLoginCheck: true, iconUrl: image4},
  {path: '/copyright', label: '版权登记', iconUrl: image5},
  {path: '/help-center', label: '帮助中心', iconUrl: image6},
])
const jumpUrl = (item) => {
  if(!item.path) {
    window.open('https://www.dfshuke.com/news?id=' + item.id)
  } else {
    if(item.isLoginCheck) {
      if(isLogin()) {
        router.push(item.path)
      }
    } else {
      router.push(item.path)
    }
  }
}
</script>
<style scoped lang="scss">
@use './var.scss' as var;
.list {
  display: grid;
  grid-template: 87rem / repeat(6, 154rem);
  grid-column-gap: 20rem;
  width: 100%;
  overflow-x: scroll;
  padding: 10rem 20rem;
  &-item {
    cursor: pointer;
    border-radius: 10rem;
    overflow: hidden;
    position: relative;
    @include var.bgconfig;
    &:hover {
      opacity: .9;
    }
    .span-icon {
      position: absolute;
      left: 12rem;
      top: 0;
      width: 20rem;
      height: 23rem;
      background-image: url(@/assets/img/bookmark.png);
      @include var.bgconfig;
    }
    .span-label {
      position: absolute;
      left: 10rem;
      bottom: 5rem;
      width: calc(154rem - 2 * 10rem);
      @include var.word-online;
      font-size: 12rem;
      // font-weight: 700;
      font-weight: normal;
      color: #FFFFFF;
    }
  }
}
</style>